<template>
  <div class="water-pay-record">
    <breadcrumb :breadcrumb="breadcrumb" />
    <div class="search-line">
      <div class="btn-box">
        <!--<button-add :pathName="addCustom"/>-->
        <el-date-picker
          v-model="timeValue"
          type="daterange"
          size="small"
          unlink-panels
          @change="changeTimeValue"
          value-format="yyyy-MM-dd"
          range-separator="至"
          :picker-options="pickerOptions2"
          start-placeholder="开始日期"
          end-placeholder="结束日期">
        </el-date-picker>
<!--        <button-cancel value="批量修改发票状态" @cancel="updatePatchElectricConsumptionRecord" style="margin-left: 10px;" />-->
      </div>
      <div style="display: flex;justify-content: space-between">
        <input-select selectTitle="充值类型" :selectKey="'payChannel'" :selectData="payChannelList" @search="search" selectWidth="100px"/>
        <input-select selectTitle="充值状态" style="margin-left: 10px;" :selectData="statusList" @search="search" selectWidth="100px" :selectKey="'status'" />
      </div>
      <div style="display: flex;justify-content: space-between">
        <input-search placeholder="住户名称/充值人姓名/房间号" @search="searchKey" style="margin-right: 5px;" />
        <button-export
          :href="exportUrl"
          download="download.xls"
          :beforeDownload="beforeDownload"
          value="导出"
          v-if="permissionCodes.indexOf('013010001') !== -1"/>
      </div>
    </div>
    <table-main :tableHead="tableHead" :tableData="tableData" @changeSelection="changeSelection" :total="total" :pageNum="pageNum" :pageSize="pageSize" @changePagination="changePagination" :hasOperation="false" :operationArr="operationArr" @modifyInvoiceStatus="modifyInvoiceStatus" @statusChange="statusChange" @statusInfoChange="statusInfoChange" />
  </div>
</template>

<script>
  import Breadcrumb from '../../../components/Breadcrumb/Breadcrumb'
  import ButtonAdd from '../../../components/Button/ButtonAdd'
  import ButtonDelete from '../../../components/Button/ButtonDelete'
  import ButtonExport from '../../../components/common/buttons/button-export'
  import ButtonUpload from '../../../components/common/buttons/button-upload'
  import InputSearch from '../../../components/Input/InputSearch'
  import InputSelect from '../../../components/Input/InputSelect'
  import TableMain from '../../../components/Table/TableMain'
  import {api} from '../../api/Finance'
  import {errorHandler} from '../../../utils/errorHandler'
  import {bus} from '../../../utils/bus'
  import {nError, nSuccess} from '../../../utils/notice'
  import ButtonCancel from '../../../components/Button/ButtonCancel'

  export default {
    components: {
      ButtonCancel,
      TableMain,
      InputSelect,
      InputSearch,
      ButtonUpload,
      ButtonExport,
      ButtonDelete,
      ButtonAdd,
      Breadcrumb},
    name: 'water-finance-pay-record',
    data () {
      return {
        permissionCodes: '',
        breadcrumb: [{
          value: '智慧财务',
          name: 'finance-over-view'
        }, {
          value: '充值记录'
        }],
        // addCustom: 'amount-add',
        exportUrl: '',
        operationArr: ['modifyInvoiceStatus'],
        pickerOptions2: {
          disabledDate (time) {
            return time.getTime() > new Date(((new Date) / 1000 + 86400) * 1000)
          },
          shortcuts: [{
            text: '最近一周',
            onClick (picker) {
              const end = new Date()
              const start = new Date()
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7)
              picker.$emit('pick', [start, end])
            }
          }, {
            text: '最近一个月',
            onClick (picker) {
              const end = new Date()
              const start = new Date()
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30)
              picker.$emit('pick', [start, end])
            }
          }, {
            text: '最近三个月',
            onClick (picker) {
              const end = new Date()
              const start = new Date()
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90)
              picker.$emit('pick', [start, end])
            }
          }]
        },
        payStatusList: [{
          key: '',
          label: '全部'
        }, {
          key: '0',
          label: '未缴费'
        }, {
          key: '1',
          label: '已缴费'
        }],
        tableHead: [{
          prop: 'rentName',
          label: '住户名称'
        }, {
          prop: 'roomName',
          label: '房间号'
        }, {
          prop: 'personName',
          label: '充值人名称',
          width: '90px'
        }, {
          prop: 'personPhone',
          label: '充值人手机'
        }, {
          prop: 'money',
          label: '充值金额(元)',
          width: '100px'
        }, {
          prop: 'payChannelText',
          label: '充值类型',
          width: '90px'
        }, {
          prop: 'statusText',
          label: '充值状态',
          width: '90px'
        }, {
          prop: 'consumeTime',
          label: '充值时间'
        }],
        tableData: [],
        total: 0,
        pageSize: 10,
        pageNum: 1,
        selectionArr: [],
        timeValue: [],
        requestData: {
          searchKey: '',
          payChannel: '',
          status: ''
        },
        payChannelList: [
          {
            key: '',
            label: '全部'
          }, {
            key: '1',
            label: '微信充值'
          }, {
            key: '5',
            label: '手动充值'
          }
        ],
        statusList: [
          {
            key: '',
            label: '全部'
          }, {
            key: '2',
            label: '充值失败'
          }, {
            key: '1',
            label: '充值成功'
          }, {
            key: '6',
            label: '审批中'
          }
        ],
        currentLineData: {}
      }
    },
    created () {
      this.permissionCodes = bus.global.permissionCodes
      this.getCurrentTime()
    },
    activated() {
      this.getPage()
    },
    methods: {
      getCurrentTime () {
        let nowDate = new Date
        let year = nowDate.getFullYear()
        let month = (nowDate.getMonth() + 1) < 10 ? '0' + (nowDate.getMonth() + 1) : (nowDate.getMonth() + 1)
        let date = nowDate.getDate() < 10 ? '0' + nowDate.getDate() : nowDate.getDate()
        // let hour = nowDate.getHours() < 10 ? '0' + nowDate.getHours() : nowDate.getHours()
        // let minute = nowDate.getMinutes() < 10 ? '0' + nowDate.getMinutes() : nowDate.getMinutes()
        // let second = nowDate.getSeconds() < 10 ? '0' + nowDate.getSeconds() : nowDate.getSeconds()
        this.timeValue[0] = year + '-' + month + '-' + date
        this.timeValue[1] = year + '-' + month + '-' + date
        this.getPage()
      },
      beforeDownload () {
        let startTime = ''
        let endTime = ''
        if (this.timeValue) {
          if (this.timeValue.length > 0) {
            startTime = `${this.timeValue[0]} 00:00:00`
            endTime = `${this.timeValue[1]} 23:59:59`
          }
        }
        this.exportUrl = `${api.exportWaterConsumptionRecord}?yq-app-code=${bus.global.yqCode}&kj-type=gy&token=${bus.global.token}&searchKey=${this.requestData.searchKey}&payChannel=${this.requestData.payChannel}&startTime=${startTime}&endTime=${endTime}&status=${this.requestData.status}`
      },
      changeTimeValue () {
        this.pageNum = 1
        this.pageSize = 10
        this.getPage()
      },
      getPage () {
        let reqData = this.requestData
        reqData.pageNum = this.pageNum
        reqData.pageSize = this.pageSize
        reqData.startTime = ''
        reqData.endTime = ''
        if (this.timeValue) {
          if (this.timeValue.length > 0) {
            reqData.startTime = `${this.timeValue[0]} 00:00:00`
            reqData.endTime = `${this.timeValue[1]} 23:59:59`
          }
        }
        this.$axios.post(api.getWaterConsumptionRecord, reqData)
          .then(res => {
            let data = res.data.data.list
            data.map(v => {
              v.code = v.outTradeNo
              if (v.payTime) {
                v.payTime = v.payTime.slice(0, 19)
              }
              if (v.status === '2') {
                v.statusText = '充值失败'
              } else if (v.status === '1') {
                v.statusText = '充值成功'
              } else if (v.status === '6') {
                v.statusText = '审批中'
              }
              if (v.payChannel === '1') {
                v.payChannelText = '微信充值'
              } else if (v.payChannel === '5') {
                v.payChannelText = '手动充值'
              }
              v.invoiceStatusChangeStatus = true
            })
            this.total = res.data.data.total
            this.tableData = data
          })
          .catch(errorHandler('获取金额信息失败'))
      },
      searchKey (v) {
        this.pageNum = 1
        this.requestData.searchKey = v
        this.getPage()
      },
      search (v) {
        this.pageNum = 1
        this.requestData[v.key] = v.value
        this.getPage()
      },
      changePagination (data) {
        this.pageNum = data[0]
        this.pageSize = data[1]
        this.getPage()
      },
      changeSelection (codeArr) {
        console.log(codeArr)
        this.selectionArr = codeArr
      },
      modifyInvoiceStatus (data) {
        // if (data.invoiceStatus === '1') {
        //   nError('已开票的不允许修改')
        //   return false
        // } else {
        //
        // }

        data.invoiceStatusChangeStatus = false
        this.currentLineData = data
      },
      // 修改开票状态
      statusChange (data) {
        this.currentLineData.invoiceStatus = data
        for (let i in this.currentLineData) {
          if (this.currentLineData[i] === '--') {
            this.currentLineData[i] = ''
          }
        }
        if (data === '0') {
          this.$axios.post(api.updateWaterConsumptionRecord, this.currentLineData)
            .then(res => {
              nSuccess('修改成功')
              this.getPage()
            })
            .catch(errorHandler('修改失败'))
        }
      },
      // 修改发票号
      statusInfoChange () {
        if (!this.currentLineData.invoiceNo) {
          nError('请输入发票号')
          return false
        }
        this.$axios.post(api.updateWaterConsumptionRecord, this.currentLineData)
          .then(res => {
            nSuccess('修改成功')
            this.getPage()
          })
          .catch(errorHandler('修改失败'))
      },

      // 批量修改发票状态
      updatePatchElectricConsumptionRecord () {
        let reqData = []
        let sumMoney = 0
        this.selectionArr.map(selection => {
          this.tableData.map(v => {
            if (selection === v.code && v.invoiceStatus === '0') {
              for (let i in v) {
                if (v[i] === '--') {
                  v[i] = ''
                }
              }
              reqData.push(v)
              reqData[reqData.length - 1].invoiceStatus = '1'
              sumMoney = sumMoney + parseFloat(v.money)
            }
          })
        })
        if (reqData.length === 0) {
          nError('请选择未开票的充值记录')
          return false
        }
        this.$confirm(`本次开票总金额为：${sumMoney.toFixed(2)} 元，已开票的不计入在内，请核对信息`, '温馨提示', {
          type: 'info'
        })
          .then(() => {
            this.$axios.post(api.updateWaterConsumptionRecordPatch, reqData)
              .then(res => {
                nSuccess('修改成功')
                this.getPage()
              })
              .catch(() => {
                errorHandler('修改失败')
                this.getPage()
              })
          })
          .catch(() => {
            this.getPage()
          })
      }
    }
  }
</script>

<style scoped>
  .search-line {
    display: flex;
    justify-content: space-between;
    margin: 20px 0;
  }
  .btn-box {
    display: flex;
    justify-content: flex-start;
  }
</style>

<style lang="less">
  .btn-box {
    .el-date-editor .el-range-separator {
      padding: 0;
    }
  }
  .el-input--small .el-input__inner {
    line-height: 30px;
  }
  .el-select-dropdown {
    min-height: 100px;
  }

  .water-pay-record {
    .el-date-editor {
      width: 260px!important;
    }
  }
</style>



// WEBPACK FOOTER //
// src/view/Finance/WaterFinance/WaterFinancePayRecord.vue